import React from "react";

interface HelpIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({
  width = 20,
  height = 20,
  fill = "currentColor",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM12.8284 5.15997C13.3505 5.67945 13.7181 6.3338 13.89 7.04999C14.1223 8.00802 13.9918 9.01814 13.5235 9.88562C13.0552 10.7531 12.2824 11.4165 11.354 11.748C11.149 11.821 11.004 12.003 11.004 12.22V13.002C11.004 13.2677 10.8984 13.5226 10.7105 13.7105C10.5226 13.8984 10.2677 14.004 10.002 14.004C9.73625 14.004 9.48139 13.8984 9.29348 13.7105C9.10557 13.5226 9 13.2677 9 13.002V10.988C9.00342 10.725 9.11028 10.474 9.29745 10.2893C9.48458 10.1046 9.73691 10.001 9.99983 10.001H9.993C11.098 10.001 11.996 9.10299 11.996 8.00099C11.984 7.47739 11.7676 6.97927 11.3929 6.61327C11.0183 6.24727 10.5153 6.04248 9.99152 6.04275C9.46778 6.04301 8.96495 6.2483 8.59068 6.61467C8.2164 6.98104 8.00043 7.47937 7.989 8.00299C7.987 8.55399 7.539 9.00099 6.987 9.00099C6.74019 8.99948 6.50281 8.90601 6.32123 8.73885C6.13964 8.57168 6.02689 8.34283 6.005 8.09699L6 7.94999C6.017 5.44599 8.321 3.51399 10.933 4.10799C11.6501 4.27628 12.3063 4.64048 12.8284 5.15997ZM11 16C11 16.5523 10.5523 17 10 17C9.44771 17 9 16.5523 9 16C9 15.4477 9.44771 15 10 15C10.5523 15 11 15.4477 11 16Z"
      fill={fill}
    />
  </svg>
);

export default HelpIcon;
